import ZipField from '~/components/form/ZipField'

export default function(formulateInstance) {
  formulateInstance.extend({
    components: {
      ZipField
    },
    library: {
      zip: {
        classification: 'zip',
        component: 'ZipField'
      }
    }
  })
}
